module.exports = __webpack_public_path__ + "img/service-consulting-2.797976ce.jpg";